export default context => {
  const files = [];
  for (const item of context.keys()) {
    files.push(context(item).default);
  }
  return files;
};
